<div tiimeFormTitle>I - Vigilance vis-à-vis de l'entité</div>
<div tiimeFormColumn>
  <app-mission-acceptance-form-row
    label="La documentation d'identification de l'entité est-elle satisfaisante ( K-bis, statuts et autres ) ?"
    required
    tiimeFormRow
  >
    <mat-button-toggle-group class="control-container" [formControl]="form.controls.entityIdentificationDocumentation">
      <mat-button-toggle [value]="true">Oui</mat-button-toggle>
      <mat-button-toggle [value]="false">Non</mat-button-toggle>
    </mat-button-toggle-group>
  </app-mission-acceptance-form-row>
  <app-mission-acceptance-form-row
    label="L'entité est elle présente dans un secteur d'activité à fort risque de blanchiment de capitaux ou de financement du
  terrorisme suivant le code monétaire et financier ?"
    required
    tiimeFormRow
  >
    <div class="mission-acceptance-form-row-content">
      <mat-icon
        class="mission-acceptance-form-infos pointer"
        fontSet="fontastic"
        fontIcon="icon-ic-info"
        tiimeTooltip
        [tooltipContent]="highRiskActivitySectorInfoTooltipTemplate"
      ></mat-icon>
      <ng-template #highRiskActivitySectorInfoTooltipTemplate>
        <strong>Secteurs d'activité à risque :</strong>
        <ul>
          <li>Cafés, hôtels, restaurants</li>
          <li>Entreprise du bâtiment ou des travaux publics</li>
          <li>Marchand de biens immobiliers</li>
          <li>Vente de véhicules d'occasion</li>
          <li>Buraliste, Point de vente de la Française des jeux ou du PMU</li>
          <li>Commerce de jetons non fongibles (NFT)</li>
          <li>Bijoutier ou commerce de métaux précieux</li>
          <li>Gardiennage, sécurité, nettoyage</li>
          <li>Activité d'import/export ou de négoce international de matières premières</li>
          <li>E-commerce</li>
        </ul>
      </ng-template>
      <mat-button-toggle-group class="control-container" [formControl]="form.controls.highRiskActivitySector">
        <mat-button-toggle [value]="true">Oui</mat-button-toggle>
        <mat-button-toggle [value]="false">Non</mat-button-toggle>
      </mat-button-toggle-group>
    </div>
  </app-mission-acceptance-form-row>
  <app-mission-acceptance-form-row
    label="Existe-t-il des changements juridiques fréquents de structures ou d'associés / dirigeants ?"
    required
    tiimeFormRow
  >
    <mat-button-toggle-group class="control-container" [formControl]="form.controls.frequentLegalChanges">
      <mat-button-toggle [value]="true">Oui</mat-button-toggle>
      <mat-button-toggle [value]="false">Non</mat-button-toggle>
    </mat-button-toggle-group>
  </app-mission-acceptance-form-row>
</div>
<div tiimeFormTitle>II - Vigilance vis-à-vis du bénéficiaire effectif et de l'actionnariat</div>
<div tiimeFormColumn>
  <app-mission-acceptance-form-row
    label="Les éléments obtenus sur l'entité permettent-ils d'identifier le bénéficiaire effectif au sens des articles R.
  561-1à3 du code monétaire et financier ?"
    required
    tiimeFormRow
  >
    <mat-button-toggle-group class="control-container" [formControl]="form.controls.effectiveBeneficiaryIdentified">
      <mat-button-toggle [value]="true">Oui</mat-button-toggle>
      <mat-button-toggle [value]="false">Non</mat-button-toggle>
    </mat-button-toggle-group>
  </app-mission-acceptance-form-row>
  <app-mission-acceptance-form-row
    label="Possède-t-on la pièce d'identité du ou des bénéficiaires effectifs ?"
    required
    tiimeFormRow
  >
    <mat-button-toggle-group class="control-container" [formControl]="form.controls.effectiveBeneficiaryIdentityPiece">
      <mat-button-toggle [value]="true">Oui</mat-button-toggle>
      <mat-button-toggle [value]="false">Non</mat-button-toggle>
    </mat-button-toggle-group>
  </app-mission-acceptance-form-row>
  <app-mission-acceptance-form-row
    label="Existe-t-il parmi les actionnaires ou dirigeants des personnes politiquement exposées (PPE) ?"
    required
    tiimeFormRow
  >
    <mat-button-toggle-group class="control-container" [formControl]="form.controls.directorsPoliticallyExposed">
      <mat-button-toggle [value]="true">Oui</mat-button-toggle>
      <mat-button-toggle [value]="false">Non</mat-button-toggle>
    </mat-button-toggle-group>
  </app-mission-acceptance-form-row>
  <app-mission-acceptance-form-row
    label="Existe-t-il des doutes sur l'intégrité et la réputation des actionnaires ou dirigeants ?"
    required
    tiimeFormRow
  >
    <mat-button-toggle-group class="control-container" [formControl]="form.controls.directorsIntegrityDoubts">
      <mat-button-toggle [value]="true">Oui</mat-button-toggle>
      <mat-button-toggle [value]="false">Non</mat-button-toggle>
    </mat-button-toggle-group>
  </app-mission-acceptance-form-row>
</div>
<div tiimeFormTitle>III - Vigilance à l'égard des opérations réalisées par l'entité</div>
<div tiimeFormColumn>
  <app-mission-acceptance-form-row
    label="Les opérations de l’exercice sont-elles cohérentes avec notre connaissance de l’entité ?"
    required
    tiimeFormRow
  >
    <mat-button-toggle-group class="control-container" [formControl]="form.controls.periodOperationsConsistent">
      <mat-button-toggle [value]="true">Oui</mat-button-toggle>
      <mat-button-toggle [value]="false">Non</mat-button-toggle>
    </mat-button-toggle-group>
  </app-mission-acceptance-form-row>
  <app-mission-acceptance-form-row label="Existe-t-il des opérations complexes ?" required tiimeFormRow>
    <mat-button-toggle-group class="control-container" [formControl]="form.controls.complexOperations">
      <mat-button-toggle [value]="true">Oui</mat-button-toggle>
      <mat-button-toggle [value]="false">Non</mat-button-toggle>
    </mat-button-toggle-group>
  </app-mission-acceptance-form-row>
  <app-mission-acceptance-form-row label="Existe-t-il des montants anormalement élevés ?" required tiimeFormRow>
    <mat-button-toggle-group class="control-container" [formControl]="form.controls.irregularHighAmounts">
      <mat-button-toggle [value]="true">Oui</mat-button-toggle>
      <mat-button-toggle [value]="false">Non</mat-button-toggle>
    </mat-button-toggle-group>
  </app-mission-acceptance-form-row>
  <app-mission-acceptance-form-row
    label="Existe-t-il des opérations sans justifications économiques ?"
    required
    tiimeFormRow
  >
    <mat-button-toggle-group class="control-container" [formControl]="form.controls.operationsWithoutEconomicProofs">
      <mat-button-toggle [value]="true">Oui</mat-button-toggle>
      <mat-button-toggle [value]="false">Non</mat-button-toggle>
    </mat-button-toggle-group>
  </app-mission-acceptance-form-row>
  <app-mission-acceptance-form-row label="L'origine des fonds est-elle suffisamment justifiée ?" required tiimeFormRow>
    <mat-button-toggle-group class="control-container" [formControl]="form.controls.fundsOriginsJustified">
      <mat-button-toggle [value]="true">Oui</mat-button-toggle>
      <mat-button-toggle [value]="false">Non</mat-button-toggle>
    </mat-button-toggle-group>
  </app-mission-acceptance-form-row>
  <app-mission-acceptance-form-row
    label="Existe-t-il des transactions avec des pays faisant partie de la liste des pays nécessitant une vigilance suivant le
  Groupe d'Action Financière (GAFI) ?"
    required
    tiimeFormRow
  >
    <div class="mission-acceptance-form-row-content">
      <mat-icon
        class="mission-acceptance-form-infos pointer"
        fontSet="fontastic"
        fontIcon="icon-ic-info"
        tiimeTooltip="Voir la liste des pays"
        (click)="openGafi()"
      ></mat-icon>
      <mat-button-toggle-group class="control-container" [formControl]="form.controls.riskedTransactions">
        <mat-button-toggle [value]="true">Oui</mat-button-toggle>
        <mat-button-toggle [value]="false">Non</mat-button-toggle>
      </mat-button-toggle-group>
    </div>
  </app-mission-acceptance-form-row>
  <app-mission-acceptance-form-row
    label="La vérification de l'identification du gérant ou du mandataire social représentant de la société est-elle en
  adéquation avec les éléments en notre possession ?"
    required
    tiimeFormRow
  >
    <mat-button-toggle-group class="control-container" [formControl]="form.controls.representantIdentificationValid">
      <mat-button-toggle [value]="true">Oui</mat-button-toggle>
      <mat-button-toggle [value]="false">Non</mat-button-toggle>
    </mat-button-toggle-group>
  </app-mission-acceptance-form-row>
</div>
<div tiimeFormTitle>Conclusions</div>
<div class="conclusions-container" tiimeFormColumn>
  <span>
    <span class="bold">Conclusion I :&nbsp;</span>
    @if (form.controls.identityConclusion.value) {
      <span [innerHTML]="form.controls.identityConclusion.value | safe: 'html'"></span>
    }
  </span>
  <span>
    <span class="bold">Conclusion II :&nbsp;</span>
    @if (form.controls.shareholdingConclusion.value) {
      <span [innerHTML]="form.controls.shareholdingConclusion.value | safe: 'html'"></span>
    }
  </span>
  <span>
    <span class="bold">Conclusion III :&nbsp;</span>
    @if (form.controls.operationsConclusion.value) {
      <span [innerHTML]="form.controls.operationsConclusion.value | safe: 'html'"></span>
    }
  </span>
  <span>
    <span class="bold">Conclusion générale :&nbsp;</span>
    @if (form.controls.globalConclusion.value) {
      <span [innerHTML]="form.controls.globalConclusion.value | safe: 'html'"></span>
    }
  </span>
</div>
